export * from "../RepositoryPaginated/IRepositoryPaginated";
